const getCustomerItemsGlobalVars = () => [];

export default getCustomerItemsGlobalVars;
